import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/layout'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr')({
  component: HRLayout,
})

function HRLayout() {
  return (
    <Layout>
      <ModuleGuard moduleKey="hr">
        <Outlet />
      </ModuleGuard>
    </Layout>
  )
}
